import { useOrganisationsAccess } from '../people/OrganisationsPage';
import { can, useSession } from '../../lib/session';

/**
 * Which of the organisation's settings the signed-in person may open (task 102). The sidebar's Settings
 * group and Tenant 360's tabs both read it, so a tab is there exactly when its page would load.
 */
export function useSettingsAccess() {
  const { tenant } = useSession();
  const organisations = useOrganisationsAccess();
  const platform = tenant?.kind === 'platform';
  // Insurers and brokers; a business on its own has none of these.
  const staff = !!tenant && !platform && tenant.kind !== 'business';
  const s = {
    platform,
    studio: can(tenant, 'config.view'),
    people: can(tenant, 'people.view'),
    roles: can(tenant, 'roles.view'),
    branding: tenant?.kind !== 'business' && can(tenant, 'organisation.edit'),
    notices: staff && can(tenant, 'notices.view'),
    clientFields: staff && can(tenant, 'client_fields.create', 'client_fields.edit', 'client_fields.delete'),
    insurerForms: staff && can(tenant, 'intake.view'),
    integrations: staff && can(tenant, 'api_keys.view', 'webhooks.view'),
    apiKeys: staff && can(tenant, 'api_keys.view'),
    providers: platform,
    organisations,
  };
  return { ...s, any: Object.entries(s).some(([k, v]) => k !== 'platform' && k !== 'apiKeys' && v) };
}
export type SettingsAccess = ReturnType<typeof useSettingsAccess>;
